import styled from 'styled-components'
import { rem } from 'polished'
import TextButton from 'LuxKit/Button/TextButton'
import RHFInput from './RHFInput'
import { mediaQueryUp } from 'components/utils/breakpoint'

export const UppercaseInput = styled(RHFInput)`
  input {
    text-transform: uppercase;
    height: ${rem(44)};
  }
`

export const CustomLookupContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, auto);
  gap: ${rem(8)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(2, 4fr) 2fr;
    grid-template-rows: 1fr;
    gap: ${rem(16)};
  }
`

export const FindFlightButton = styled(TextButton)`
  height: ${rem(44)};
`
